import script from "./Page12.vue?vue&type=script&setup=true&lang=js"
export * from "./Page12.vue?vue&type=script&setup=true&lang=js"

import "./Page12.vue?vue&type=style&index=0&id=b23f93bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b23f93bc"]])

export default __exports__